import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerUserService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CustomerUserDto,
} from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetAllCustomerUserList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  // status?: number[]
  // isEnabled?: boolean[]
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CustomerUserDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, status, isEnabled, _force } = tableInfo;

  const allCustomerUserList = useQuery(
    [
      'getAllCustomerUserList',
      status,
      isEnabled,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        CustomerUserService.getApiCustomerApiAppCustomerUserCustomerUserList(
          status,
          isEnabled ? isEnabled : [true],
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
    // {
    //   keepPreviousData: true,
    // }
  );
  return allCustomerUserList;
};

export default useGetAllCustomerUserList;
